"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Logo;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Logo(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 24",
        height: "24",
        fill: "currentColor"
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9266 2.77812C11.1535 1.85664 9.77994 1.73645 8.85862 2.50966L6.72414 4.30102C7.42905 4.53734 8.07972 4.96482 8.5926 5.57616L10.8594 8.27813L14.1934 5.48009L11.9266 2.77812ZM2.70749 5.06119L7.57328 0.977574C9.34059 -0.505639 11.9754 -0.275078 13.4584 1.49255L16.3679 4.96056C16.5383 5.16373 16.6211 5.4263 16.598 5.6905C16.5749 5.95471 16.4478 6.19891 16.2447 6.36939L14.304 7.99804L17.0226 11.2385C18.5055 13.0061 18.275 15.6414 16.5077 17.1246L9.48201 23.021C9.48143 23.0214 9.48084 23.0219 9.48026 23.0224C7.71295 24.5056 5.0781 24.2751 3.59515 22.5075L0.233916 18.501C0.063469 18.2978 -0.0193037 18.0352 0.0038073 17.771C0.0269183 17.5068 0.15402 17.2626 0.357151 17.0922L4.45943 13.6493L2.19261 10.9473C0.709658 9.17973 0.940178 6.5444 2.70749 5.06119ZM5.74477 15.1814L2.4084 17.9815L5.12696 21.2219C5.90003 22.1434 7.2736 22.2636 8.19492 21.4903C9.11623 20.7171 9.2364 19.3433 8.46333 18.4218L5.74477 15.1814ZM10.9262 19.1981C10.816 18.4627 10.508 17.7476 9.99514 17.1363L3.72442 9.66178C2.95135 8.7403 3.07152 7.36648 3.99283 6.59327C4.91414 5.82006 6.28771 5.94026 7.06079 6.86173L9.97028 10.3297C10.1407 10.5329 10.3849 10.66 10.649 10.6832C10.9132 10.7063 11.1757 10.6235 11.3789 10.453L12.7722 9.28362L15.4908 12.524C16.2639 13.4455 16.1437 14.8193 15.2224 15.5926L10.9262 19.1981Z"
    }));
}

//# sourceMappingURL=Logo.js.map